import { render, staticRenderFns } from "./StoreOrderPage.vue?vue&type=template&id=37582f23&"
import script from "./StoreOrderPage.vue?vue&type=script&lang=js&"
export * from "./StoreOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports